<h2 mat-dialog-title>New Note</h2>
<div mat-dialog-content>
    <p>(Members' notes are only visible to EICDataStream Users within your own organisation)</p>
    <textarea
        name="txtNewNote"
        [(ngModel)]="memberNoteText"
        rows="8"
        cols="35"
        class="form-control input-sm"
        style="width:90%;"
        [maxLength]="maxNoteLength">
    </textarea>
    <div>{{ charsLeft }} characters left</div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSave" (click)="save()">Save</button>
</div>
